var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7367F0",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13H31C32.7 13 34 14.3 34 16V26C34 27.7 32.7 29 31 29H24V31H27C27.6 31 28 31.4 28 32C28 32.6 27.6 33 27 33H19C18.4 33 18 32.6 18 32C18 31.4 18.4 31 19 31H22V29H15C13.3 29 12 27.7 12 26V16C12 14.3 13.3 13 15 13ZM31 27C31.6 27 32 26.6 32 26V16C32 15.4 31.6 15 31 15H15C14.4 15 14 15.4 14 16V26C14 26.6 14.4 27 15 27H31Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1803_14273",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13H31C32.7 13 34 14.3 34 16V26C34 27.7 32.7 29 31 29H24V31H27C27.6 31 28 31.4 28 32C28 32.6 27.6 33 27 33H19C18.4 33 18 32.6 18 32C18 31.4 18.4 31 19 31H22V29H15C13.3 29 12 27.7 12 26V16C12 14.3 13.3 13 15 13ZM31 27C31.6 27 32 26.6 32 26V16C32 15.4 31.6 15 31 15H15C14.4 15 14 15.4 14 16V26C14 26.6 14.4 27 15 27H31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1803_14273)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 24,
    height: 24,
    fill: "#7367F0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgProfit);
export default __webpack_public_path__ + "static/media/avg-profit.0f19bbf4877cddc4a811d125ba40c610.svg";
export { ForwardRef as ReactComponent };